export enum ArticulationType {
  NORMAL = 'normal',
  LEGATO = 'legato',
  MUTED = 'muted',
  HARMONIC = 'harmonic',
  SQUARE = 'square',
  TRIANGLE = 'triangle',
  CROSS_CIRCLE = 'crossCircle',
  HAMMER_ON = 'hammerOn',
  PULL_OFF = 'pullOff',
  UP_BOW = 'upBow',
  DOWN_BOW = 'downBow',
  OPEN = 'open',
  CLOSED = 'closed',
  FERMATA = 'fermata',
  MARCATO = 'marcato',
  MARTELLATO = 'martellato',
  STACCATO = 'staccato',
  STACCATISSIMO = 'staccatissimo',
  TENUTO = 'tenuto',
  BUZZ = 'buzz',
  PIZZICATO = 'pizzicato',
  SPICCATO = 'spiccato',
}
